import * as React from 'react';
import {
    closeCurrentTimeStreamProject,
    openTimeStreamProject,
    ProjectId,
} from 'owa-timestream-store';

export default function useOpenOutlookSpace(projectId: ProjectId) {
    return React.useCallback(
        (e?: React.SyntheticEvent) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            closeCurrentTimeStreamProject();
            openTimeStreamProject(projectId);
        },
        [projectId]
    );
}
